export const standOutProductId = 'caaf594b-bae5-4593-a546-3a8efdc87421';
export const brandedProductId = 'abfb62a2-4fbe-4c74-bf84-1ef148f5ff54';
export const premiumProductId = 'eff97c5e-679d-4954-a5c1-2638bbb704fd';
export const premiumAsiaProductId = '0483344c-8ccf-46d0-a9ec-1615d73733ad';
export const JOB_AD_EDIT_PRODUCT_ID = 'f033be8f-e2c8-44fc-a50e-5f59f0644b2c';
